// Marcas da legenda do mapa de calor: sempre do 0 ao máximo, com 25/50/75% no meio.
// Os valores são inteiros (marcas repetidas viram uma só).
export const buildTickPositions = max => {
  const top = max > 0 ? max : 1
  const ticks = [0, top * 0.25, top * 0.5, top * 0.75, top]

  return [...new Set(ticks.map(Math.round))]
}

export default buildTickPositions
